module.exports = __webpack_public_path__ + "LatoLatin-BlackItalic.30639dd3ee15815c559c.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-BlackItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-BlackItalic.eot
// module chunks = styles